// gine_eng/src/features/student/components/ManyStudentCreateModal.jsx
import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";

import { fetchStudents, createBulkStudent } from "../studentSlice";

import Modal from "../../../components/Modal";
import CloseButton from "../../../components/CloseButton";
import { DataGrid, textEditor } from "react-data-grid";
import "react-data-grid/lib/styles.css";

const columns = [
  {
    key: "name",
    name: "이름",
    width: 150,
    renderEditCell: textEditor,
    frozen: true,
  },
  {
    key: "grade",
    name: "학년",
    width: 50,
    renderEditCell: textEditor,
    frozen: true,
  },
  {
    key: "student_phone",
    name: "학생 전화번호",
    width: 304,
    minWidth: 300,
    renderEditCell: textEditor,
    frozen: true,
  },
  {
    key: "parent_phone",
    name: "부모 전화번호",
    width: 304,
    renderEditCell: textEditor,
  },
];

const ManyStudentCreateModal = ({ setIsManyStudentModalOpen }) => {
  const dispatch = useDispatch();
  const [selectedCell, setSelectedCell] = useState({
    rowIdx: -1,
    columnIdx: -1,
  });

  const [rows, setRows] = useState([
    {
      name: "",
      grade: 0,
      student_phone: "",
      parent_phone: "",
    },
  ]);

  const handleRowsChange = (updatedRows, { indexes }) => {
    setRows(updatedRows);
  };

  const handlePaste = (event) => {
    const clipboardData = event.clipboardData.getData("text/plain");
    const pastedRows = clipboardData
      .trim()
      .split("\n")
      .map((row) => row.split("\t"));

    setRows((prevRows) => {
      const newRows = prevRows.map((row) => ({ ...row }));
      for (let rowIdx = 0; rowIdx < pastedRows.length; rowIdx++) {
        for (let colIdx = 0; colIdx < pastedRows[rowIdx].length; colIdx++) {
          const realColIdx = selectedCell.columnIdx + colIdx;
          const realRowIdx = selectedCell.rowIdx + rowIdx;

          if (realRowIdx >= newRows.length) {
            newRows.push({
              name: "",
              grade: 0,
              student_phone: "",
              parent_phone: "",
            });
          }
          if (realColIdx == 0) {
            newRows[realRowIdx].name = pastedRows[rowIdx][colIdx];
          } else if (realColIdx == 1) {
            newRows[realRowIdx].grade = pastedRows[rowIdx][colIdx];
          } else if (realColIdx == 2) {
            newRows[realRowIdx].student_phone = pastedRows[rowIdx][colIdx];
          } else if (realColIdx == 3) {
            newRows[realRowIdx].parent_phone = pastedRows[rowIdx][colIdx];
          }
        }
      }
      return newRows;
    });
    event.preventDefault();
  };

  const handleCreateRow = () => {
    const beforeRows = rows.slice(0, selectedCell.rowIdx + 1);
    const afterRows = rows.slice(selectedCell.rowIdx + 1);
    const newRow = {
      name: "",
      grade: 0,
      student_phone: "",
      parent_phone: "",
    };

    setRows([...beforeRows, newRow, ...afterRows]);
  };

  const handleDeleteRow = () => {
    if (selectedCell.rowIdx === -1 || selectedCell.rowIdx > rows.length - 1) {
      return alert("삭제할 행을 선택해주세요.");
    }
    const beforeRows = rows.slice(0, selectedCell.rowIdx);
    const afterRows = rows.slice(selectedCell.rowIdx + 1);
    setRows([...beforeRows, ...afterRows]);
  };

  const handleAddStudent = async () => {
    for (let rowIdx = 0; rowIdx < rows.length; rowIdx++) {
      const row = rows[rowIdx];
      if (row.name === "") {
        return alert(`${rowIdx + 1}번째 줄: 이름을 입력해주세요.`);
      } else if (isNaN(row.grade) || row.grade <= 0 || row.grade > 12) {
        return alert(
          `${rowIdx + 1}번째 줄: 학년은 1~12 사이의 숫자로 입력해주세요.`
        );
      } else if (row.student_phone === "") {
        return alert(`${rowIdx + 1}번째 줄: 학생 전화번호를 입력해주세요.`);
      } else if (row.parent_phone === "") {
        return alert(`${rowIdx + 1}번째 줄: 부모 전화번호를 입력해주세요.`);
      }
    }
    try {
      await dispatch(createBulkStudent({ student_list: rows })).unwrap();
      dispatch(fetchStudents());
      alert("학생 대량 생성 완료");
    } catch (err) {
      alert(err.error);
    } finally {
      setIsManyStudentModalOpen(false);
    }
  };

  return (
    <Modal>
      <div
        style={{
          position: "relative",
          width: "900px",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          borderRadius: "18px",
          boxShadow: "0 22px 54px rgba(14, 20, 27, .18)",
          paddingBottom: "24px",
        }}
        onPaste={handlePaste}
      >
        <CloseButton onClick={() => setIsManyStudentModalOpen(false)} />
        <div
          style={{
            padding: "24px",
            fontSize: "20px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <span style={{ fontWeight: 800, letterSpacing: "-0.01em", marginRight: "6px" }}>학생 대량 입력</span>
          <button
            style={{
              backgroundColor: "#F4F8F7",
              color: "#3A434E",
              border: "1px solid #E6EDEC",
              padding: "8px 18px",
              fontSize: "14px",
              fontWeight: 700,
              borderRadius: "999px",
              cursor: "pointer",
              fontFamily: "inherit",
              transition: "background-color .12s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#E5FBF8")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#F4F8F7")}
            onClick={handleCreateRow}
          >
            행 추가
          </button>
          <button
            style={{
              backgroundColor: "#F4F8F7",
              color: "#3A434E",
              border: "1px solid #E6EDEC",
              padding: "8px 18px",
              fontSize: "14px",
              fontWeight: 700,
              borderRadius: "999px",
              cursor: "pointer",
              fontFamily: "inherit",
              transition: "background-color .12s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#E5FBF8")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#F4F8F7")}
            onClick={handleDeleteRow}
          >
            행 삭제
          </button>
          <button
            style={{
              backgroundColor: "#0E141B",
              color: "#FFF",
              border: "none",
              padding: "9px 22px",
              fontSize: "14px",
              fontWeight: 700,
              borderRadius: "999px",
              cursor: "pointer",
              fontFamily: "inherit",
              marginRight: "40px",
              marginLeft: "auto",
              transition: "background-color .12s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#00A396")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#0E141B")}
            onClick={handleAddStudent}
          >
            + 학생 추가
          </button>
        </div>
        <div
          style={{
            width: "90%",
            fontSize: "15px",
            alignSelf: "center",
            borderRadius: "12px",
            overflow: "hidden",
            border: "1px solid #E6EDEC",
            "--rdg-border-color": "#E6EDEC",
            "--rdg-header-background-color": "#F4F8F7",
            "--rdg-row-hover-background-color": "#F2FAF8",
            "--rdg-selection-color": "#00D9C0",
          }}
        >
          <DataGrid
            columns={columns}
            rows={rows}
            onRowsChange={handleRowsChange}
            onCellClick={({ rowIdx, column }) => {
              setSelectedCell({ rowIdx, columnIdx: column.idx });
            }}
          />
        </div>
        <p
          style={{
            width: "90%",
            alignSelf: "center",
            margin: "12px 0 0",
            fontSize: "13px",
            color: "#7A8490",
          }}
        >
          💡 엑셀에서 이름·학년·전화번호를 복사한 뒤, 첫 칸을 클릭하고 붙여넣기(Ctrl+V)하면 한 번에 입력됩니다.
        </p>
      </div>
    </Modal>
  );
};

export default ManyStudentCreateModal;
